import { ErrorBoundary } from 'react-error-boundary';
import { Route, Routes } from 'react-router-dom';

import RouteWithTitle from '../../../../src/routes/RouteWithTitle';
import JobsListContextProvider from '../../../context/jobsListContext';
import ErrorLogger from '../../../providers/ErrorLogger';
import CustomizeJobFields from '../customizeJobFields/CustomizeJobFields';
import JobAttrVisibility from '../jobAttrVisibility/JobAttrVisibility';
import JobClosing from '../jobClosing/JobClosing';
import JobPostingSettings from '../jobPosting/JobPostingSettings';

export const CustomizeJobFieldsRoutes = () => (
  <Routes>
    <Route
      path="/"
      element={
        <RouteWithTitle title="Customize Job Fields - Wisestep">
          <CustomizeJobFields></CustomizeJobFields>
        </RouteWithTitle>
      }
    ></Route>
  </Routes>
);

export const JobClosingPageRoutes = () => (
  <Routes>
    <Route
      path="/"
      element={
        <RouteWithTitle title="Customize Closing Reasons - Wisestep">
          <JobClosing></JobClosing>
        </RouteWithTitle>
      }
    ></Route>
  </Routes>
);

export const JobPostingSettingsRoutes = () => (
  <Routes>
    <Route
      path="/"
      element={
        <RouteWithTitle title="Configure Job Posting - Wisestep">
          <ErrorBoundary FallbackComponent={({ error }) => <ErrorLogger error={error} />}>
            <JobsListContextProvider>
              <JobPostingSettings />
            </JobsListContextProvider>
          </ErrorBoundary>
        </RouteWithTitle>
      }
    />
  </Routes>
);
export const JobAttrVisibilityRoutes = () => (
  <Routes>
    <Route
      path="/"
      element={
        <RouteWithTitle title=" Job Attributes Visibility Settings - Wisestep">
          <JobAttrVisibility></JobAttrVisibility>
        </RouteWithTitle>
      }
    ></Route>
  </Routes>
);
